import React, { Component } from 'react'
import { toast } from 'react-toastify'
import $ from 'jquery'
import { Link } from 'react-router-dom'
// component
import Toaster from '../../Toaster/Toaster'
import agent from '../../../api/Api'
import { trackFormConfusion, trackTimeSpent } from '../../../utils/Analytics'
// css
import './SignInForm.css'
import config from '../../../config/config'

class SignInForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      passwordType: 'password',
      errorCount: {
        email: 0,
        password: 0
      }
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSignInKeyPress = this.handleSignInKeyPress.bind(this)
    this.handlePwdShowHide = this.handlePwdShowHide.bind(this)
    this.fieldTimers = {};
  }

  componentDidMount() {
    this.startTime = Date.now();
    this.currentPath = window.location.href;
  }

  handlePwdShowHide(name, type) {
    console.log(name)
    this.setState({ [name]: type === 'password' ? 'text' : 'password' })
  }

  handleInputChange(event) {
    const { name, value } = event.target
    this.setState({ [name]: value })
    if (value.length > 0) {
      $('#' + name).css({ border: '1px solid #ddd' })
    } else {
      $('#' + name).css({ border: '1px solid red' })
      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          [name]: (prev.errorCount[name] || 0) + 1
        }
      }), () => {
        if (this.state.errorCount[name] >= config.ERROR_COUNT) {
          trackFormConfusion('Sign In', name);
        }
      });
    }
  }

  handleFocus = (field) => {
    this.fieldTimers[field] = Date.now();
  };

  handleBlur = (field) => {
    if (this.fieldTimers[field]) {
      const duration = (Date.now() - this.fieldTimers[field]) / 1000;
      if (duration > config.FOCUS_TIME) {
        trackFormConfusion('Sign In', field, duration);
      }
      delete this.fieldTimers[field];
    }
  };

  handleSubmit() {
    $('#loader').fadeIn()
    let param = {
      email: this.state.email,
      password: this.state.password
    }

    let count = 0
    for (var key in param) {
      if (param[key]) {
        $('#' + key).css({ border: '1px solid #ddd' })
        count += 1
      } else {
        $('#' + key).css({ border: '1px solid red' })
        const currentKey = key;
        this.setState(prev => ({
          errorCount: {
            ...prev.errorCount,
            [currentKey]: (prev.errorCount[currentKey] || 0) + 1
          }
        }), () => {
          if (this.state.errorCount[currentKey] >= config.ERROR_COUNT) {
            trackFormConfusion('Sign In', currentKey);
          }
        });
      }
    }
    let url = ''
    if (this.props.role === 'teacher') url = '/teacher/login'
    else url = '/admin/login'
    // alert(count)
    if (count === 2) {
      agent.APILIST.teacherSignin(url, param)
        .then(res => {
          if (res.status === 'SUCCESS') {
            $('#loader').fadeOut()
            if (this.props.role === 'admin') {
              localStorage.setItem('userInfo', JSON.stringify(res.adminResponseData))
            } else {
              localStorage.setItem('userInfo', JSON.stringify(res.data))
            }
            this.props.handleSignIn('SUCCESS', this.props.role)
          }
        })
        .catch(err => {
          $('#loader').fadeOut()
          if (err.response.text) {
            console.log(err.response.text)
            let res = JSON.parse(err.response.text)
            toast.dismiss()
            toast(<Toaster title='Teacher Login' content={res.message} status='error' />)
            setTimeout(function () { toast.dismiss() }, 3000)
          }
        })
    } else {
      window.scrollTo(0, 0)
      $('#loader').fadeOut()
    }
  }

  handleSignInKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.handleSubmit()
    }
  }

  componentWillUnmount() {
    trackTimeSpent(this.props.role === 'admin' ? '/auth/admin/signin' : '/auth/teacher/signin', this.currentPath, this.startTime);
  }

  render() {
    return (
      <div id='signin-form'>
        <div className='signin-outer-blk noselect'>
          {this.props.role !== 'admin'
            ? <Link className='back-blk' to='/'>
              <img className='arrow-black-left' src={process.env.PUBLIC_URL + 'assets/images/icons/arrow-black-left.svg'} alt='arrow' />
              <p>back</p>
            </Link>
            : ''
          }
          <div className='signin-blk'>
            <div className='title-blk'>
              <p className='signin-title'>sign in</p>
              <p className='signin-desc'>{this.props.role === 'admin' ? 'Sign In here to manage masks and educators' : 'Welcome, We are happy to see you back!'}</p>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>email*</label>
                <br />
                <input type='text' autoFocus autoComplete='off' name='email' id='email' placeholder='Enter your email address' value={this.state.email} onChange={this.handleInputChange} onKeyDown={this.handleSignInKeyPress} onFocus={()=>this.handleFocus('email')} onBlur={() => this.handleBlur('email')} />
              </div>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>password*</label>
                <br />
                <input type={this.state.passwordType} autoComplete='off' name='password' id='password' placeholder='Enter your password' value={this.state.password} onChange={this.handleInputChange} onKeyDown={this.handleSignInKeyPress} onFocus={()=>this.handleFocus('password')} onBlur={() => this.handleBlur('password')} />
                <span className='pwdShow' onClick={() => this.handlePwdShowHide('passwordType', this.state.passwordType)}>
                  {this.state.passwordType === 'text'
                    ? <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_hidden.svg'} className='show-hide-icon' alt='eye' />
                    : <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_show.svg'} className='show-hide-icon' alt='eye' />
                  }
                </span>
              </div>
            </div>
            {this.props.role === 'admin'
              ? <div className='forgotPwd'><Link to='/auth/admin/forgotpassword'>Forgot Password?</Link></div>
              : <div className='forgotPwd'><Link to='/auth/teacher/forgotpassword'>Forgot Password?</Link></div>}
            <div className='submit-section'>
              <div className='submit-blk' onClick={this.handleSubmit}>
                <p className='submit-btn'>sign in</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default SignInForm
